import styled from '@emotion/styled';

const SectionHeader = styled('header')({
  marginBottom: 18,
  display: 'flex',
  alignItems: 'center',
});

export default SectionHeader;
